/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {EarningsAccountModel} from './earnings-account-api.service';
import {ADMIN_RESOURCE_PAGES} from '../common/controller/admin-resource-pages';
import {EarningsAccountEditPageComponent} from './earnings-account-edit-page.component';
import {EarningsAccountAnalysisPageComponent} from './earnings-account-analysis-page.component';

@Component({
  standalone: true,
  imports: [...ADMIN_RESOURCE_PAGES, EarningsAccountEditPageComponent, EarningsAccountAnalysisPageComponent],
  selector: 'adn-earnings-account-item-page',
  template: `
    <adn-two-panel-layout>
      <adn-earnings-account-edit-page leftPanel [state]="state"></adn-earnings-account-edit-page>
      <adn-earnings-account-analysis-page rightPanel [state]="state" [model]="state.model()" [isNew]="state.isNew()"></adn-earnings-account-analysis-page>
    </adn-two-panel-layout>
  `
})
export class EarningsAccountItemPageComponent {
  @Input() state: SignalAdminResourcePageState<EarningsAccountModel>;
}
